// Header.js
import React, { useState } from 'react';
import '../style/Header.css';

import label from '../images/PariMoskva_logo.png';


const Header = () => {
  const [navOpen, setNavOpen] = useState(false);

  // Ваш номер и ссылка на WhatsApp
  const phoneNumber = '+79811070307'; 
  const tgLink = 'https://t.me/parimoskva';
  

  return (
    <header className="hat">
      <div className="container">
        <div className="container_h">
          <img src={label} alt="Logo" className="logo" />
          <h3 className='logo_text'>ПариМосква</h3>
        </div>
        <nav>
          <ul className={navOpen ? 'open' : ''}>
             <li><a href={`tel:${phoneNumber}`} className='header_item'>+7(981)1070307</a></li>
            <li><a href={tgLink} target="_blank" rel="noopener noreferrer" className='header_item tg'>Telegram</a></li>
            <li><a href="#header" className='header_item'>Главная</a></li>
            <li><a href="#About" className='header_item'>Наши торты</a></li>
            <li><a href="#wrapper" className='header_item'>Заказ</a></li>
           
          </ul>
          <div id="mySidenav" className={`sidenav ${navOpen ? 'show' : ''}`}> 
            <button className="closebtn" onClick={() => setNavOpen(false)}>&times;</button>
            <a onClick={() => setNavOpen(false)} className='header_item' href={`tel:${phoneNumber}`}>+7(981)1070307</a>
            <a className='header_item tg' onClick={() => setNavOpen(false)} href={tgLink}  target="_blank" rel="noopener noreferrer">Telegram</a>
            <a className='header_item' onClick={() => setNavOpen(false)} href="#header">Главная</a>
            <a className='header_item' onClick={() => setNavOpen(false)} href="#About">Наши торты</a>
            <a className='header_item' onClick={() => setNavOpen(false)} href="#wrapper">Заказ</a>
            
          </div>
          <span className="sidenav-button" onClick={() => setNavOpen(true)}>&#9776;</span>
        </nav>
      </div>
    </header>
  );
};

export default Header;
